module.exports = __webpack_public_path__ + "static/terms-d1b2ddd79b28fe3760fe48b92b54c9c5.png";